import { CssBaseline } from '@mui/material'
import Router from 'router'
import Loader from 'sharedComponents/loader'
import SnackBar from 'sharedComponents/snackbar'
import { Provider } from 'react-redux'
import store from 'redux/store'
import { ThemeProvider } from '@mui/material/styles'
import theme from 'theme'
import NetworkService from 'services/network'

import './App.css'

NetworkService.setupInterceptors(store)

const App = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Loader />
          <SnackBar />
          <CssBaseline />
          <Router />
        </Provider>
      </ThemeProvider>
    </>
  )
}

export default App
